/**
 * Utilitários de validação para formulários
 */

/**
 * Valida um CPF brasileiro
 * @param {string} cpf - CPF a ser validado
 * @returns {boolean} true se o CPF é válido, false caso contrário
 */
export function validateCPF(cpf) {
    // Remove caracteres não numéricos
    const cleanedCpf = cpf.replace(/\D/g, "");

    // Verifica se tem 11 dígitos
    if (cleanedCpf.length !== 11) return false;

    // Verifica se todos os dígitos são iguais (CPFs inválidos conhecidos)
    if (/^(\d)\1{10}$/.test(cleanedCpf)) return false;

    // Calcula o primeiro dígito verificador
    let sum = 0;
    for (let i = 0; i < 9; i++) {
        sum += parseInt(cleanedCpf.charAt(i)) * (10 - i);
    }
    let remainder = sum % 11;
    let firstDigit = remainder < 2 ? 0 : 11 - remainder;

    // Calcula o segundo dígito verificador
    sum = 0;
    for (let i = 0; i < 10; i++) {
        sum += parseInt(cleanedCpf.charAt(i)) * (11 - i);
    }
    remainder = sum % 11;
    let secondDigit = remainder < 2 ? 0 : 11 - remainder;

    // Verifica se os dígitos calculados correspondem aos informados
    return firstDigit === parseInt(cleanedCpf.charAt(9)) &&
        secondDigit === parseInt(cleanedCpf.charAt(10));
}

/**
 * Valida se o usuário tem 18 anos ou mais
 * @param {string} dateStr - Data no formato YYYY-MM-DD
 * @returns {boolean} true se o usuário tem 18+ anos, false caso contrário
 */
export function isAgeValid(dateStr) {
    if (!dateStr) return false;

    const birthDate = new Date(dateStr + 'T00:00:00');
    const today = new Date();

    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();

    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
        age--;
    }

    return age >= 18;
}

/**
 * Converte data do formato YYYY-MM-DD para ISO 8601
 * @param {string} dateStr - Data no formato YYYY-MM-DD
 * @returns {string} Data no formato ISO 8601 (YYYY-MM-DDTHH:MM:SS.sssZ)
 */
export function convertBirthdateToISO(dateStr) {
    if (!dateStr) return null;
    const date = new Date(dateStr + 'T00:00:00');
    return date.toISOString();
}

/**
 * Validação de CEP usando ViaCEP com fallback para OpenCEP
 * @async
 * @param {string} cep - CEP a ser validado
 * @returns {Promise<boolean>} true se o CEP for válido, false caso contrário
 */
export async function isValidCep(cep) {
    const cleanedCep = cep.replace(/\D/g, "");
    if (cleanedCep.length !== 8) return false;

    try {
        const response = await fetch(`https://viacep.com.br/ws/${cleanedCep}/json/`);
        const data = await response.json();
        return !data.erro;
    } catch (error) {
        console.warn("ViaCEP indisponível, tentando OpenCEP...", error);
    }

    try {
        const response = await fetch(`https://opencep.com/v1/${cleanedCep}`);
        const data = await response.json();
        return data.status === 200 && !data.error;
    } catch (error) {
        console.warn("OpenCEP também indisponível, validando apenas formato...", error);
    }

    return true;
}
